// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__MQlRM","bigColWidth":"Table_bigColWidth__7Id9Z","biggerColWidth":"Table_biggerColWidth__3Y5pm","row":"Table_row__27NKM","col":"Table_col__3SVDi"};